var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconStorageFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 6,
    height: 6,
    rx: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 2,
    width: 6,
    height: 6,
    rx: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 2,
    width: 6,
    height: 6,
    rx: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9,
    width: 6,
    height: 6,
    rx: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 6,
    height: 6,
    rx: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 9,
    width: 6,
    height: 6,
    rx: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 16,
    width: 6,
    height: 6,
    rx: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 16,
    width: 6,
    height: 6,
    rx: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 6,
    height: 6,
    rx: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStorageFull);
export default ForwardRef;